module.exports = require("node-zip");


//////////////////
// WEBPACK FOOTER
// external "node-zip"
// module id = 10
// module chunks = 0